import {useEffect, useState} from "react";
import {Box, CircularProgress, Stack, Typography, Chip} from "@mui/material";
import Constants from "../../../../utils/constants";
import { authHeader } from "../../../../utils/headers";

function OperateurTourneeStats({ date, operateurId }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!date || !operateurId) return;
        let isMounted = true;
        async function fetchData() {
            setLoading(true);
            setError(null);
            try {
                const res = await fetch(Constants.API_ROUTE_DASHBOARD_OPERATEUR, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': authHeader() },
                    body: JSON.stringify({ date, operateurId })
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json = await res.json();
                if (isMounted) setData(json);
            } catch (e) {
                if (isMounted) setError(e.message || 'Erreur de chargement');
            } finally {
                if (isMounted) setLoading(false);
            }
        }
        fetchData();
        return () => { isMounted = false; }
    }, [date, operateurId]);

    if (!date || !operateurId) return null;

    return (
        <Box mt={2}>
            <Typography variant="h6" gutterBottom>Tournée - Statistiques</Typography>
            {loading && (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <CircularProgress size={16} />
                    <Typography variant="body2">Chargement…</Typography>
                </Stack>
            )}
            {error && (
                <Typography variant="body2" color="error">{error}</Typography>
            )}
            {data && (data.totalBacsLaves !== undefined || data.totalBacsImpossible !== undefined || data.ratioBacsHeure !== undefined) ? (
                <Stack direction="column" spacing={0.5} alignItems="flex-start" sx={{ width: '100%' }}>
                    {data.tourneeLibelle && (
                        <Typography variant="subtitle2">{data.tourneeLibelle}</Typography>
                    )}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center">
                        <Chip size="small" label={`${data.totalBacsLaves ?? 0} lavé(s)`} sx={{ bgcolor: 'rgba(123,180,33,0.15)', color: '#7bb421' }} />
                        <Chip size="small" label={`${data.totalBacsImpossible ?? 0} impossible(s)`} sx={{ bgcolor: 'rgba(178,34,34,0.12)', color: '#B22222' }} />
                        <Chip size="small" label={`${data.ratioBacsHeure ?? 0} bacs/h`} />
                    </Stack>
                </Stack>
            ) : data?.interventions?.length > 0 ? (
                <Stack direction="column" spacing={1}>
                    {data.interventions.map((it, idx) => (
                        <Box key={idx} sx={{
                            border: '1px solid #eee',
                            borderRadius: 1,
                            padding: '8px 12px'
                        }}>
                            <Typography variant="subtitle2">{it.campagneLibelle}</Typography>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center">
                                <Chip size="small" label={`${it.nombreBacsLaves} lavé(s)`} sx={{ bgcolor: 'rgba(123,180,33,0.15)', color: '#7bb421' }} />
                                <Chip size="small" label={`${it.nombreBacsImpossible} impossible(s)`} sx={{ bgcolor: 'rgba(178,34,34,0.12)', color: '#B22222' }} />
                                <Chip size="small" label={`${it.ratioBacsHeure} bacs/h`} />
                            </Stack>
                        </Box>
                    ))}
                </Stack>
            ) : (!loading && !error) ? (
                <Typography variant="body2" color="textSecondary">Aucune donnée de tournée</Typography>
            ) : null}
        </Box>
    );
}

export default OperateurTourneeStats;
